// extracted by mini-css-extract-plugin
module.exports = {"CounterContainer":"TimeCounter_CounterContainer__3XSJ1","TimeExpired":"TimeCounter_TimeExpired__3kk-t","Counter":"TimeCounter_Counter__1xewp"};